import { Link } from "react-router-dom";
import { UserRound, Stethoscope, Clock, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { can, ROLE_LABELS, NAV, roleOf } from "@/lib/constants";
import { useLoad } from "@/lib/api";
import { PageHeader, StatCard, NeedClinic } from "@/components/common";
import ExecutiveDashboard from "./ExecutiveDashboard";

function StaffHome() {
  const { user } = useAuth();
  const [d] = useLoad("/home");
  if (d && !d.clinic) return <NeedClinic />;
  const links = (NAV[roleOf(user)] || []).filter((n) => n.to !== "/dashboard");
  return (
    <>
      <PageHeader eyebrow={ROLE_LABELS[user.role]} title={`Hello, ${user.name.split(" ")[0]}`} subtitle={d?.clinic ? `${d.clinic.name} · ${d.clinic.country}` : ""} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Patients registered" value={d?.patients ?? "—"} icon={UserRound} testId="home-stat-patients" />
        <StatCard label="Visits today" value={d?.visits_today ?? "—"} icon={Stethoscope} tone="indigo" testId="home-stat-visits-today" delay={60} />
        <StatCard label="Waiting queue" value={d?.waiting ?? "—"} icon={Clock} tone="amber" testId="home-stat-waiting" delay={120} />
        <StatCard label="Active staff" value={d?.staff ?? "—"} icon={Users} tone="green" testId="home-stat-staff" delay={180} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {links.map((l) => (
          <Link key={l.to} to={l.to} data-testid={`home-quick-${l.to.slice(1)}`} className="group rounded-2xl border border-slate-200 bg-white p-5 hover:border-teal-500/50 transition-colors">
            <l.icon className="h-5 w-5 text-teal-700" />
            <p className="mt-4 font-display font-semibold text-slate-900 group-hover:text-teal-700">{l.label}</p>
          </Link>
        ))}
      </div>
    </>
  );
}

export default function Dashboard() {
  const { user, clinics } = useAuth();
  if (can(user, "finance")) {
    if (!clinics.length) return <NeedClinic isCeo={user.role === "ceo"} />;
    return <ExecutiveDashboard />;
  }
  return <StaffHome />;
}
